export default "__VITE_ASSET__XB29lMqG__"